import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { LocationTableActionComponent } from 'ml-capability-quoteandbind-common-react';

import metadata from './MLLocationListPopup.metadata.json5';

import React from 'react';

const MLLocationListPopup = (props) => {
    const {
        submissionVM,
        editLocation,
        removeLocation,
        onCancel
    } = props;

    const overrides = {
        locationTableActionComponent: {
            submissionVM,
            hideAdd: true,
            onEdit: editLocation,
            onRemove: removeLocation,
            onCancel,
            showLocMayNotBeRemovedAlert: false
        }
    };

    const resolvers = {
        resolveComponentMap: {
            locationTableActionComponent: LocationTableActionComponent
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );

};

MLLocationListPopup.propTypes = {
    submissionVM: PropTypes.object,
    editLocation: PropTypes.func,
    removeLocation: PropTypes.func,
    onCancel: PropTypes.func
};

export default MLLocationListPopup;
